module.exports = __webpack_public_path__ + "img/tabler_edit.148ee574.svg";